import Vue from 'vue';
import * as d3 from 'd3';

function countDecimals(number) {
  if (Math.floor(number.valueOf()) == number.valueOf()) {
    return 0;
  }
  return number.toString().split('.')[1].length;
}

function scientificToDecimal(rawNumber) { // https://gist.github.com/jiggzson/b5f489af9ad931e3d186
  let number = rawNumber.toString()
  let numberHasSign = number.startsWith("-") || number.startsWith("+");
  let sign = numberHasSign ? number[0] : "";
  number = numberHasSign ? number.replace(sign, "") : number;
  //if the number is in scientific notation remove it
  if (/\d+\.?\d*e[\+\-]*\d+/i.test(number)) {
    let zero = '0';
    let parts = String(number).toLowerCase().split('e'); //split into coeff and exponent
    let e = parts.pop();//store the exponential part
    let l = Math.abs(e); //get the number of zeros
    let sign = e / l;
    let coeff_array = parts[0].split('.');
    if (sign === -1) {
      coeff_array[0] = Math.abs(coeff_array[0]);
      number = zero + '.' + new Array(l).join(zero) + coeff_array.join('');
    } else {
      let dec = coeff_array[1];
      if (dec) l = l - dec.length;
      number = coeff_array.join('') + new Array(l + 1).join(zero);
    }
  }
  return `${sign}${number}`;
}

function makeFormatterFor(number) {
  const decimalPlaces = countDecimals(scientificToDecimal(number));
  if (decimalPlaces > 0) {
    const formatString = `,.${decimalPlaces}f`;
    return d3.format(formatString);
  }
  return d3.format(',')
}

Vue.filter('formatNumber', (input) => {
  if (!input) {
    return '';
  }
  const inputNoSpaces = input.toString().replace(/\s+/g, '');
  if (
    !Number.isNaN(inputNoSpaces - 0) && 
    !Number.isNaN(parseFloat(inputNoSpaces - 0))
  ) {
    const formatter = makeFormatterFor(input);
    return formatter(input);
  }
  return input;
});
